<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useAssessmentTemplatesApi } from '../api/assessment-templates/list.hook'
import TableAssessmentTemplates from './assessment-templates/TableAssessmentTemplates.vue'
import ModalCreateAssessmentTemplate from './assessment-templates/modals/ModalCreateAssessmentTemplate.vue'
import ModalDeleteAssessmentTemplate from './assessment-templates/modals/ModalDeleteAssessmentTemplate.vue'
import ModalDuplicateAssessmentTemplate from './assessment-templates/modals/ModalDuplicateAssessmentTemplate.vue'

defineOptions({
  name: 'AssessmentsListPage',
})

onMounted(() => {
  void useAssessmentTemplatesApi()
})

// Timestamps arrive pre-shifted into the admin's view timezone (§0), so a timezone change really
// does need a refetch rather than a client-side re-format.
useOnTimezoneChange(() => {
  void useAssessmentTemplatesApi()
})
</script>

<template>
  <TableAssessmentTemplates />
  <ModalCreateAssessmentTemplate />
  <ModalDeleteAssessmentTemplate />
  <ModalDuplicateAssessmentTemplate />
</template>
